import { Show } from 'solid-js'
import ConsentButton from './ConsentButton'
import { COPY } from './copy'

export interface ConsentBannerProps {
  gpc: boolean
  busy: boolean
  privacyUrl: string
  onReject: () => void
  onCustomize: (e?: Event) => void
  onAccept: () => void
  /** CCPA "Do Not Sell or Share My Personal Information": marketing off */
  onDoNotSell: () => void
}

/** First layer: non-modal bottom bar, no focus trap, three equal buttons. */
export default function ConsentBanner(props: ConsentBannerProps) {
  return (
    <section
      role="region"
      aria-labelledby="consent-title"
      aria-busy={props.busy ? 'true' : 'false'}
      data-testid="consent-banner"
      class="tc-bottom fixed inset-x-0 px-4 md:px-6"
    >
      <div class="mx-auto flex max-w-[1200px] flex-col gap-4 rounded-xl border border-[color:var(--tc-border)] bg-[var(--tc-surface)] p-4 text-[color:var(--tc-text)] shadow-2xl md:p-5 lg:flex-row lg:items-center lg:justify-between">
        <div class="min-w-0">
          <h2 id="consent-title" class="m-0 text-base font-semibold">
            {COPY.bannerTitle}
          </h2>
          <p class="m-0 mt-1 text-sm text-[color:var(--tc-text-2)]">
            {COPY.bannerBody}{' '}
            <a
              href="#cookie-settings"
              data-testid="consent-banner-settings"
              class="underline text-[color:var(--tc-accent)]"
              onClick={(e) => {
                e.preventDefault()
                props.onCustomize(e)
              }}
            >
              {COPY.settingsLink}
            </a>
            {' · '}
            <a href={props.privacyUrl} target="_blank" rel="noopener" data-testid="consent-privacy-link" class="underline text-[color:var(--tc-accent)]">
              {COPY.privacyLink}
            </a>
            {' · '}
            <a
              href="#do-not-sell"
              data-testid="consent-banner-dns"
              aria-disabled={props.busy ? 'true' : undefined}
              class="underline text-[color:var(--tc-accent)]"
              onClick={(e) => {
                e.preventDefault()
                if (!props.busy) props.onDoNotSell()
              }}
            >
              {COPY.ccpaLink}
            </a>
          </p>
          <Show when={props.gpc}>
            <p data-testid="consent-gpc-notice" class="m-0 mt-2 text-[12px] text-[color:var(--tc-success)]">
              {COPY.gpc}
            </p>
          </Show>
        </div>
        <div class="flex flex-col gap-2 sm:flex-row sm:gap-3 lg:shrink-0" data-testid="consent-banner-actions">
          <ConsentButton label={COPY.rejectAll} testId="consent-reject" disabled={props.busy} onClick={props.onReject} />
          <ConsentButton label={COPY.customize} testId="consent-customize" disabled={props.busy} onClick={props.onCustomize} />
          <ConsentButton label={COPY.acceptAll} testId="consent-accept" disabled={props.busy} onClick={props.onAccept} />
        </div>
      </div>
    </section>
  )
}
